<button
  [type]="type"
  (click)="onClick.emit($event)"
  [disabled]="disabled || loading"
  [ngClass]="[
    variantClasses[variant],
    sizeClasses[size],
    fullWidth ? 'w-full' : '',
    'relative cursor-pointer inline-flex items-center justify-center font-bold overflow-hidden transition-all duration-300 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed group'
  ]"
>
  @if (loading) {
    <span class="absolute inset-0 flex items-center justify-center bg-inherit z-10">
      <svg class="animate-spin h-5 w-5 text-current" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
    </span>
  }
    <span [class.opacity-0]="loading" class="flex items-center gap-2">
      <ng-content select="[icon]"></ng-content>
      @if (iconName) {
        <ng-icon [name]="iconName" size="18" class="group-hover:scale-110 transition-transform"></ng-icon>
      }
      <ng-content></ng-content>
      {{ label }}
    </span>
</button>